'use strict'
const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

const anios = ['2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020']

const i18n = {
  autoClose: true,
  months: meses,
  monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  cancel: 'Cancelar',
  done: 'Seleccionar',
  setDefaultDate: true
}

const empresas = {
  tonoDigital: 'tonodigital',
  gmCel: 'gmcel'
}





const controles = {
  macrosstech: [
    {
      user: 'BASE UNEFON',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'BASE ATT',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'BASE MOVISTAR',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'ANA DANIELA CUEVAS CANTOR',
      rutas: ['administrarBase',]
    },
    {
      user: 'JACQUELINE QUINTANAR GONZALEZ',
      rutas: ['administrarBase',]
    },
    {
      user: 'JOVANA ELIZABETH GUZMAN LUNA',
      rutas: ['administrarBase',]
    },
    {
      user: 'LUIS ALBERTO HERNANDEZ LUCIANO',
      rutas: ['administrarBase',]
    },
    {
      user: 'JANERY ALEXANDER SANCHEZ IRIARTE',
      rutas: ['administrarBase',]
    },
    {
      user: 'EDUARDO ANTONIO HERNANDEZ MENDOZA',
      rutas: ['administrarBase',]
    }
  ],

  demo: [
    {
      user: 'pruebaAdmin',
      rutas: ['recargas', 'portabilidades']
    },
    {
      user: 'demo2',
      rutas: ['usuarios', 'administrarBase', 'ventas' , 'subirArchivos', 'recargas' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar'],
      permisosRecargas: ['Reciclar', 'movimientos']
    },
    {
      user: 'demo3',
      rutas: ['usuarios', 'administrarBase', 'ventas' , 'subirArchivos' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar']
    },
    {
      user: 'demo1',
      rutas: ['usuarios', 'administrarBase', 'ventas' , 'subirArchivos' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar']
    }
  ],
  cmtex: [
    {
      user: 'MESA1OWEN',
      rutas: ['recargas',  'usuarios', 'recargasMasivas', 'subirArchivos', 'administrarBase', 'ventas' ],
      permisosArchivos: ['Recargas Masivas']
    },{
      user: 'MESA2PEDRO',
      rutas: ['recargas',  'usuarios', 'recargasMasivas', 'subirArchivos', 'administrarBase', 'ventas' ],
      permisosArchivos: ['Recargas Masivas']
    },{
      user: 'ABIGAILGNRAL',
      rutas: ['recargas',  'usuarios', 'recargasMasivas', 'subirArchivos', 'administrarBase', 'ventas' ],
      permisosArchivos: ['Recargas Masivas']
    },{
      user: 'VAZQUEZACTV',
      rutas: ['administrarBase', 'ventas' , 'subirArchivos', 'recargas' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar'],
      permisosRecargas: ['Reciclar', 'movimientos']
    },{
      user: 'YATZIRIALMC',
      rutas: ['administrarBase', 'subirArchivos' ],
      permisosArchivos: ['Registrar nuevos', 'Reemplazar', 'Eliminar']
    }
  ],

  gsmoviles: [{
    user: 'AdminEli',
    rutas: ['recargas', 'portabilidades']
  }],
  todosim: [{
    user: 'CESAR',
    rutas: ['subirArchivos', 'administrarBase', 'recargas']
  },{
    user: 'ADRIANA',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'COMODIN2',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'COMOSIN1',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'FERNANDA',
    rutas: ['recargas', 'portabilidades']
  },{
    user: 'PAOLA',
    rutas: ['recargas', 'portabilidades']
  }],
  discovery:[
    {
      user: 'SegundoNivel',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    },{
      user: 'ALEJANDRA AGUILAR',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    },{
      user: 'ANGELICA ROJAS ARZATE',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    },{
      user: 'BRENDA ORTIZ OCAMPO',
      rutas: ['recargas', 'portabilidades','subirArchivos', 'administrarBase','ventas','recicladoMasivo'],
    },
    {
      user: 'TercerNivel',
      rutas: ['recargas']
    }
  ],
  comint:[
    {
      user: 'usuarioRecargas',
      rutas: ['recargas'],
    }
  ]

}

const permisos = {
  RECARGAS_MASIVAS: 'RECARGAS_MASIVAS',
  RETROALIMENTACION_LIDER: 'RETROALIMENTACION_LIDER',
  MONTO_LIDER: 'MONTO_LIDER',
  MOVI_DN: 'MOVI_SIN_DN',
  ATT_DN: 'ATT_SIN_DN',
  GRAFICAS: 'GRAFICAS',
  PORTABILIDADES: 'PORTABILIDADES',
  USUARIO_CLIENTE: 'USUARIO_CLIENTE',
  INVENTARIO: 'INVENTARIO',
  RECARGA_EXTERNA: 'RECARGA_EXTERNA',
  RECARGAS_CARRIER: 'RECARGAS_CARRIER',
  RECARGAS_PLATAFORMA: 'RECARGAS_PLATAFORMA',
  PERMISO_MONTOS: 'PERMISO_MONTOS',
  RECICLADO_MASIVO: 'RECICLADO_MASIVO'
}

module.exports = {
  i18n,
  meses,
  anios,
  empresas,
  permisos,
  controles
}
